export enum LangTypeEnum {
  RU = 'ru',
}

export interface ILang {
  title: string;
  lang: LangTypeEnum;
}
